import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { EcautomateService } from '../../services/ecautomate.service';

@Component({
  selector: 'app-ec-farm-graph-view',
  templateUrl: './ec-farm-graph-view.page.html',
  styleUrls: ['./ec-farm-graph-view.page.scss'],
})
export class EcFarmGraphViewPage implements OnInit {

  // clientId: any = 'papp-3546';
  @Input() clientId: any;

  constructor(
    private ecAutomate: EcautomateService
  ) { }

  ngOnInit(): void {
    // console.log(this.clientId);
    this.createChartTemp();
    // this.ecAutomate.sensorGraphData({
    //   clientId: this.clientId, temp: true,
    //   hours: 6
    // }).subscribe((graphData: any) => {
    //   if (graphData.data.length > 0) {
    //     this.updateChartData(graphData.data); // Fetch and update data here
    //   };
    // });

    // this.ecAutomate.sensorGraphData({
    //   clientId: this.clientId, temp: false,
    //   hours: 6
    // }).subscribe((graphData: any) => {
    //   if (graphData.data.length > 0) {
    //     this.updateChartDataHumidity(graphData.data); // Fetch and update data here
    //   };
    // });

    // this.ecAutomate.relayGraphData({
    //   clientId: this.clientId,
    //   hours: 6
    // }).subscribe((graphData: any) => {
    //   console.log(graphData.data.length)
    //   if (graphData.data.length > 0) {
    //     this.updateChartDataRelay(graphData.data[0]); // Fetch and update data here
    //   }
    // });

  };

  private createChartTemp() {
    Highcharts.chart('container2', {
      chart: {
        type: 'line'
      },
      title: {
        text: 'Temperature Data',
      },
      xAxis: {
        type: 'datetime'
      },
      yAxis: {
        title: {
          text: 'Temperature',
        },
      },
      series: [],
    });

    Highcharts.chart('container3', {
      chart: {
        type: 'line'
      },
      title: {
        text: 'Humidity Data',
      },
      xAxis: {
        type: 'datetime'
      },
      yAxis: {
        title: {
          text: 'Humidity',
        },
      },
      series: [],
    });

    Highcharts.chart('container4', {
      chart: {
        type: 'line'
      },
      title: {
        text: 'Relay',
      },
      xAxis: {
        type: 'datetime'
      },
      yAxis: {
        title: {
          text: 'ON/OFF',
        },
      },
      series: [],
    });
  };

  private updateChartData(graphData) {
    // Replace this with your actual data fetching logic
    const sensorData = this.fetchSensorData(graphData);

    // Access the chart instance and add series for each sensor
    const chart = Highcharts.charts[0];

    chart.addSeries({
      name: 'Sensor 1',
      type: 'line',  // Add the type property
      data: sensorData.sensor1,
    });

    chart.addSeries({
      name: 'Sensor 2',
      type: 'line',  // Add the type property
      data: sensorData.sensor2,
    });

    chart.addSeries({
      name: 'HeatIndex',
      type: 'line',  // Add the type property
      data: sensorData.sensor3,
    });

    chart.addSeries({
      name: 'Avg Temp',
      type: 'line',  // Add the type property
      data: sensorData.sensor4,
    });
  };

  private updateChartDataHumidity(graphData) {
    // Replace this with your actual data fetching logic
    const sensorData = this.fetchSensorDataHumidity(graphData);

    // Access the chart instance and add series for each sensor
    const chart = Highcharts.charts[1];

    chart.addSeries({
      name: 'Sensor 1',
      type: 'line',  // Add the type property
      data: sensorData.sensor1,
    });

    chart.addSeries({
      name: 'Sensor 2',
      type: 'line',  // Add the type property
      data: sensorData.sensor2,
    });

    chart.addSeries({
      name: 'Avg Humidity',
      type: 'line',  // Add the type property
      data: sensorData.sensor3,
    });
  };

  private updateChartDataRelay(graphData) {
    // Replace this with your actual data fetching logic
    const sensorData = this.fetchSensorDataRelay(graphData);

    // Access the chart instance and add series for each sensor
    const chart = Highcharts.charts[2];
    for (let i = 0; i < graphData.name.length; i++) {
      chart.addSeries({
        name: graphData.name[i],
        type: 'line',  // Add the type property
        data: sensorData[i],

      });
    }

  };

  private fetchSensorDataRelay(graphData) {
    let sensorData = [];

    for (let i = 0; i < graphData.ecStatus.length; i++) {
      const dateObject = new Date(graphData.ecStatus[i].date);

      for (let j = 0; j < graphData.ecStatus[i].status.length; j++) {
        // Ensure sensorData[j] is initialized as an array
        if (!sensorData[j]) {
          sensorData[j] = [];
        };

        // console.log(graphData.ecStatus[i].status[j]);
        sensorData[j].push([dateObject.getTime(), graphData.ecStatus[i].status[j]]);
      };
    };
    return sensorData;
  };

  // Replace this with your actual data fetching logic
  private fetchSensorData(graphData) {

    const sensorData = {
      sensor1: [],
      sensor2: [],
      sensor3: [],
      sensor4: [],
    };

    for (let i = 0; i < graphData.length; i++) {
      const dateObject = new Date(graphData[i].date);
      sensorData.sensor1.push([dateObject.getTime(), graphData[i].tempSensor1]); // Replace with actual data
      sensorData.sensor2.push([dateObject.getTime(), graphData[i].tempSensor2]); // Replace with actual data
      sensorData.sensor3.push([dateObject.getTime(), graphData[i].heatIndex]); // Replace with actual data
      sensorData.sensor4.push([dateObject.getTime(), graphData[i].avgTemperature]); // Replace with actual data
    }
    return sensorData;
  };

  // Replace this with your actual data fetching logic
  private fetchSensorDataHumidity(graphData) {

    const sensorData = {
      sensor1: [],
      sensor2: [],
      sensor3: []
    };

    for (let i = 0; i < graphData.length; i++) {
      const dateObject = new Date(graphData[i].date);
      sensorData.sensor1.push([dateObject.getTime(), graphData[i].humSensor1]); // Replace with actual data
      sensorData.sensor2.push([dateObject.getTime(), graphData[i].humSensor2]); // Replace with actual data
      sensorData.sensor3.push([dateObject.getTime(), graphData[i].avgHumidity]); // Replace with actual data
    }
    return sensorData;
  };

  doRefresh(event) {
   this.ngOnInit();
    setTimeout(() => {
      event.target.complete();
    }, 2000);
  };

}
